import Vue from 'vue';
import Vuex from 'vuex';

import login from './modules/login';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState({
    // isLoading/loadingCount son estado transitorio de la sesión actual, no
    // algo que deba sobrevivir a un refresco. Si el usuario cierra o
    // recarga la pestaña justo mientras una petición está en curso
    // (isLoading:true en ese instante), sin este reducer ese "true" se
    // guarda tal cual en localStorage; en la siguiente carga (aunque sea
    // login) Vuex lo restaura, y como no hay ninguna petición real en
    // marcha que lo apague, el spinner se queda encendido para siempre.
    reducer (state) {
      const persisted = { ...state };
      delete persisted.isLoading;
      delete persisted.loadingCount;
      return persisted;
    }
  })],
  state: {
    isLoading: false,
    loadingCount: 0,
    // adminMenu: true,
    itemData: null,
    headerData: null
  },
  mutations: {
    // Varias peticiones pueden estar en curso a la vez (ej. la vista de
    // carpetas dispara varias llamadas en paralelo). Se usa un contador en
    // lugar de un booleano para que el spinner no desaparezca mientras
    // todavía queden peticiones pendientes.
    loadingOn (state) {
      state.loadingCount++
      state.isLoading = true
    },
    // adminMenu(state, payload) {
    //   state.adminMenu = payload;
    // },
    loadingOff (state) {
      state.loadingCount = Math.max(0, state.loadingCount - 1)
      state.isLoading = state.loadingCount > 0
    },
    storeItemData(state, itemData) {
      state.itemData = itemData
    },
    storeHeaderData(state, headerData) {
      state.headerData = headerData
    }
  },
  actions: {
    isLoadingOn({commit}) {
      commit('loadingOn')
    },
    isLoadingOff({commit}) {
      commit('loadingOff')
    },
    itemData({commit}, itemData) {
      commit('storeItemData', itemData)
    },
    headerData({commit}, headerData) {
      commit('storeHeaderData', headerData)
    },
    // adminMenu({commit}, payload) {
    //   commit('adminMenu', payload);
    // },
  },
  getters: {
    itemData: (state) => {
      return state.itemData;
    },
    headerData: (state) => {
      return state.headerData;
    },
    isLoading: (state) => {
      return state.isLoading;
    },
    // adminMenu:(state) => {
    //   return state.adminMenu
    // },
  },
  modules: {
    login
  }
})

// El reducer de arriba evita que isLoading/loadingCount se guarden a partir
// de ahora, pero no "cura" por sí solo una sesión cuyo localStorage ya
// tuviera isLoading:true guardado de antes de este cambio (createPersistedState
// restaura ese localStorage al construir el store, ANTES de esta línea). Se
// fuerza el reseteo aquí, tras la rehidratación, para blindar también ese
// caso: el spinner nunca debe arrancar ya encendido, pase lo que pase.
store.state.isLoading = false;
store.state.loadingCount = 0;

export default store;